import { type Command } from '@telespot/core';

/**
 * @group Protocols
 * @category Payloads
 */
export interface UpdatePipelineAlgorithmDetails {
  pipelineStepId: string;
  algorithmId: string | undefined;
}

/**
 * @group Protocols
 * @category Tokens
 */
export const UPDATE_PIPELINE_ALGORITHM = 'protocols:updatePipelineAlgorithm';

export class UpdatePipelineAlgorithm
  implements Command<typeof UPDATE_PIPELINE_ALGORITHM, UpdatePipelineAlgorithmDetails>
{
  public readonly name = UPDATE_PIPELINE_ALGORITHM;
  constructor(public readonly details: UpdatePipelineAlgorithmDetails) {}
}
